import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import styles from '../styles.scss';

const Answer = ({
  answer,
  onBackClick,
  onNextClick,
  finishQuiz,
  isStepLast,
}) => (
  <div className={styles.answer}>
    <div className={styles.title}>{answer.title || ''}</div>
    <div className={styles.view}>{answer.view}</div>
    <div className={styles.text}>
      <b className={styles.main}>{answer.main}</b>
      {answer.text}
    </div>
    <div className={styles.btns}>
      <Button onClick={onBackClick}>
        <KeyboardArrowLeft />
        Back
      </Button>
      {isStepLast ? (
        <Button onClick={finishQuiz}>
          Finish
          <KeyboardArrowRight />
        </Button>
      ) : (
        <Button onClick={onNextClick}>
          Next
          <KeyboardArrowRight />
        </Button>
      )}
    </div>
  </div>
);

Answer.propTypes = {
  answer: PropTypes.object,
  onBackClick: PropTypes.func,
  onNextClick: PropTypes.func,
  finishQuiz: PropTypes.func,
  isStepLast: PropTypes.bool,
};

export default Answer;
